const list = [
  'KKPAR-API-1'
  // 'KKPAR-API-2',
  // 'KKPAR-API-3',
  // 'KKPAR-API-4',
  // 'KKPAR-API-5',
  // 'KKPAR-API-6',
  // 'KKPAR-API-7',
  // 'KKPAR-API-19',
  // 'KKPAR-API-20',
  // 'KKPAR-API-21',
  // 'KKPAR-API-22',
  // 'KKPAR-API-36',
  // 'KKPAR-API-41',
  // 'KKPAR-API-47',
  // 'KKPAR-API-63',
  // 'KKPAR-API-64',
  // 'KKPAR-API-65',
  // 'KKPAR-API-75',
  // 'KKPAR-API-88',
  // 'KKPAR-API-89',
  // 'KKPAR-API-90',
  // 'KKPAR-API-92',
  // 'KKPAR-API-9998',
  // 'KKPAR-API-9999'
]

export default list
